<template>
  <a-modal
    :title="$t('title.seedingPositionBind')"
    :centered="true"
    :visible="visible"
    width="40%"
    :destroyOnClose="destroyOnClose"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel">
    <a-spin :spinning="loading">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item :label="$t('business.label.container')">
          <span>{{ containerFactoryView.container.no }}</span>
        </a-descriptions-item>
        <a-descriptions-item :label="$t('business.label.seedingPosition')">
          <a-input-search
            class="query"
            @dblclick="searchLocation()"
            @pressEnter="searchLocation()"
            @search="searchLocation()"
            v-model="seedingPosition.no"
          />
        </a-descriptions-item>
      </a-descriptions>
      <location-modal ref="locationModal" @change="selectLocation" />
    </a-spin>
  </a-modal>
</template>
<script>
import { post } from '@/api/Api'
import { ContainerFactoryView } from '@/api/dto/view/ContainerFactoryView'
import { Location } from '@/api/dto/common/Location'
import LocationModal from '@/views/modal/LocationModel.vue'
import Api from '@/api'

export default {
  name: 'SeedingPositionBind',
  components: { LocationModal },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      destroyOnClose: true,
      containerFactoryView: new ContainerFactoryView(),
      seedingPosition: new Location(),
      loading: false
    }
  },
  methods: {
    open(containerFactoryView) {
      if (containerFactoryView) {
        Object.assign(this.containerFactoryView, containerFactoryView)
        this.visible = true
      }
    },
    handleOk() {
      this.confirmLoading = true
      let args = { rackNo: this.containerFactoryView.container.no, locationNo: this.seedingPosition.no }
      post(Api.containerBindSeedingPosition, { type: 'generalHandler' }, args).then(res => {
        if (res.success) {
          this.$emit('success')
          let that = this
          this.$success({
            title: '绑定成功',
            onOk() {
              that.handleCancel()
            },
            okText: '确定',
            centered: true
          })
        }
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    handleCancel() {
      this.visible = false
    },
    searchLocation() {
      this.$refs.locationModal.open({ zoneType: 5 })
    },
    selectLocation(loc) {
      if (loc.length > 0) {
        this.seedingPosition = Object.assign(new Location(), loc[0])
      } else {
        this.seedingPosition = new Location()
      }
    }
  }
}
</script>